import { Box, Collapse, Flex, Link, Stack, Text } from "@chakra-ui/react";
import Icon from "./ui-elements/Icon";
import { format } from "date-fns";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { getWeekDay } from "../utils/functions";

type Props = {
  store: any;
  [key: string]: any;
};

const CallResponseSummary = observer(({ store, ...rest }: Props) => {
  const [show, setShow] = React.useState(false);
  const handleShow = () => setShow(!show);

  const tutorResponse = store.tutorResponse;
  const callSummary = tutorResponse.callFeedback?.callSummary;
  const startDate = tutorResponse.callFeedback?.startDate;

  const lessonStart = format(new Date(startDate), "MMMM Do");
  // console.log({"here":""})
  return (
    <Box
      mx={[5, 6]}
      p={[5, 5]}
      bg={show ? "white" : "neutral.100"}
      borderWidth="2xs"
      rounded="fbRadius"
      onClick={handleShow}
      _hover={{
        borderColor: "gray.300",
        cursor: "pointer",
      }}
      {...rest}
    >
      <Flex direction={["column", "row"]}>
        <Flex mb={[5, 0]} justifyContent="space-between">
          <Icon name="checkmark" color="green.500" size={8} mr={[0, 5]} />

          <Stack
            isInline
            align="center"
            color="blue.500"
            onClick={handleShow}
            display={["block", "none"]}
          >
            <Link fontSize="sm">{show ? "Hide details" : "View details"}</Link>
            <Icon name={show ? "chevron-up" : "chevron-down"} />
          </Stack>
        </Flex>
        <Stack flex={1}>
          <Flex justifyContent="space-between">
            <Box>
              <Text fontWeight="bold" lineHeight="none">
                Submitted call feedback
              </Text>
              <Stack mt={1} isInline align="center" opacity={0.7}>
                <Icon name="calendar" size={3} />
                {lessonStart !== "Invalid date" ? (
                  <Text fontSize="sm">
                    To start: {getWeekDay(startDate)} {lessonStart}
                  </Text>
                ) : (
                  <Text fontSize="sm">Start date: Not yet set</Text>
                )}
              </Stack>
            </Box>

            <Stack
              isInline
              align="center"
              color="blue.500"
              display={["none", "block"]}
              onClick={handleShow}
            >
              <Link fontSize="sm">
                {show ? "Hide details" : "View details"}
              </Link>
              <Icon name={show ? "chevron-up" : "chevron-down"} />
            </Stack>
          </Flex>

          {show && (
            <Collapse in={show}>
              <Box mt={2}>
                <Text>{callSummary}</Text>
              </Box>
            </Collapse>
          )}
        </Stack>
      </Flex>
    </Box>
  );
});

export default CallResponseSummary;
